package org.example.project.utils

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Style

@Composable
fun UserAvatarCircle(
    user: All?,
    fallbackLabel: String = "",
    sizePx: Int = 42,
    imageSrc: String = userAvatarSrc(user),
    offsetX: Double = userAvatarOffsetX(user),
    offsetY: Double = userAvatarOffsetY(user),
    zoom: String = userAvatarZoom(user),
    background: String? = null,
    onClick: (() -> Unit)? = null
) {
    Style(UserAvatarCircleStyles)

    Div({
        classes(UserAvatarCircleStyles.avatarCircle)
        style {
            width(sizePx.px)
            height(sizePx.px)
            fontSize((sizePx * 0.34).px)
            background?.let { property("background", it) }
        }
        if (onClick != null) onClick { onClick() }
    }) {
        Span({ classes(UserAvatarCircleStyles.avatarInitials) }) {
            org.jetbrains.compose.web.dom.Text(userAvatarInitials(user, fallbackLabel))
        }
    }
}

fun userAvatarSrc(user: All?): String = ""

fun userAvatarInitials(user: All?, fallbackLabel: String = ""): String {
    user?.kuerzel?.takeIf { it.isNotBlank() }?.let { return it.take(2).uppercase() }
    val first = user?.vorname?.firstOrNull { it.isLetter() }?.uppercaseChar()?.toString().orEmpty()
    val last = user?.nachname?.firstOrNull { it.isLetter() }?.uppercaseChar()?.toString().orEmpty()
    val fromName = (first + last).ifBlank {
        user?.name?.take(2).orEmpty()
    }.ifBlank {
        fallbackLabel.split(Regex("\\s+"))
            .filter { it.isNotBlank() }
            .take(2)
            .joinToString("") { it.first().uppercaseChar().toString() }
    }
    return fromName.ifBlank { "US" }.take(2).uppercase()
}

private fun userAvatarOffsetX(user: All?): Double = 0.0

private fun userAvatarOffsetY(user: All?): Double = 0.0

private fun userAvatarZoom(user: All?): String = "1"

private object UserAvatarCircleStyles : StyleSheet() {
    val avatarCircle by style {
        borderRadius(50.percent)
        overflow("hidden")
        position(Position.Relative)
        property("background", "linear-gradient(180deg, rgba(255,255,255,0.10) 0%, rgba(255,255,255,0.04) 100%)")
        property("border", "1px solid rgba(255,255,255,0.16)")
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        color(Color.white)
        fontWeight("900")
        property("flex-shrink", "0")
        padding(0.px)
        margin(0.px)
        boxSizing("border-box")
    }

    val avatarImage by style {
        position(Position.Absolute)
        left(50.percent)
        top(50.percent)
        maxWidth(100.percent)
        maxHeight(100.percent)
        property("width", "auto")
        property("height", "auto")
        property("object-fit", "contain")
        property("transform-origin", "center center")
        property("will-change", "transform")
    }

    val avatarInitials by style {
        lineHeight("1")
        textAlign("center")
    }
}
